import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { SESSION_EXPIRED_DIALOG } from '../loginpages/actionCreators';
import * as constants from '../common/constants';
import { getLabelFromJspVariables } from '../common/JspUtil';

const SessionExpiredDialog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const open = useSelector(state => state.authenticateReducer.sessionExpired);

    const handleOk = () => {
        dispatch({ type: SESSION_EXPIRED_DIALOG, data: false });
        navigate(constants.ROUTE_PAGE_LOGIN);
    };

    return (
        <Dialog
            id="sessionExpiredDialog"
            data-automation-id="session_expired_dialog"
            open={!!open}
            onClose={handleOk}
            aria-labelledby="session-expired-title"
            aria-describedby="session-expired-desc"
        >
            <DialogTitle id="session-expired-title" severity="error" data-automation-id="session_expired_title">{getLabelFromJspVariables('title_session_expired')}</DialogTitle>
            <DialogContent>
                <Typography id="session-expired-desc" variant="body2">{getLabelFromJspVariables('note_session_expired')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleOk} data-automation-id="session_expired_ok_btn">{getLabelFromJspVariables('action_ok')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredDialog;
